import { Component, OnInit, ViewChild } from '@angular/core';
const screenfull = require('screenfull');
const browser = require('jquery.browser');
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;
import { NotificationService } from '../../shared/services/notification.service';
import { UserblockService } from '../sidebar/userblock/userblock.service';
import { AppSettingsService } from '../../shared/services/appsettings.service';
import { MenuService } from '../../core/menu/menu.service';
import { AuthService } from '../../shared/services/authentication.service';
import { ClientService } from '../../shared/services/client/client.service';
import { ClientViewModel } from '../../model/client/ClientViewModel';
import { LoadingContainer, LoadingPage } from '../../shared/LoadingContainer';
@Component({
    selector: 'app-header',
    template: require('./header.component.html'),
    styles: [require('./header.component.scss')]
})
export class HeaderComponent extends LoadingPage {

    clients = new Array<any>();
    actualClient = new ClientViewModel;
    navCollapsed = true; // for horizontal layout
    menuItems: any[] = []; // for horizontal layout

    isNavSearchVisible: boolean;
    @ViewChild('fsbutton') fsbutton: any;  // the fullscreen button

    constructor(
        private menu: MenuService,
        private userblockService: UserblockService,
        private settings: AppSettingsService,
        private authService: AuthService,
        private clientService: ClientService,
        private route: ActivatedRoute,
        private router: Router,
        protected notificationService: NotificationService) {
        super(true);
        // show only a few items on demo
        this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout

    }

    ngOnInit() {
        this.isNavSearchVisible = false;


        this.getClientData();

        if (browser.msie) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }
    }

    private getClientData() {
        this.standby();
        this.clientService.getActualClient().then(response => {
            this.ready();
            this.actualClient = response;
        }).catch(e => {
            this.ready();
            this.notificationService.handleGlobalErrors(e);
        });
        this.clientService.getAvailableClients().then(response => {
            this.clients = response;
        }).catch(e => {
            this.ready();
            this.notificationService.handleGlobalErrors(e);
        });

    }

    onClientChanged($event: Event) {
        this.standby();
        this.clientService.setActualClientId(this.actualClient.Id).then(response => {
            this.notificationService.showSuccess('app.notification.SUCCESS', response.message, response);       
            setTimeout(function () { location.reload() }, 500);
            this.ready();
        }).catch(e => {
            this.ready();
            this.notificationService.handleGlobalErrors(e);
        });

    }

    onLogout() {
        this.authService.logout();
        window.location.reload();        
    }

    toggleUserBlock(event: any) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }
    hasClientComprehensive(): boolean {

        return this.authService.hasRole('ClientComprehensiveAdministration');
    }

    openNavSearch(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.layout.offsidebarOpen = !this.settings.layout.offsidebarOpen;
    }

    toggleCollapsedSideabar() {
        this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
    }

    isCollapsedText() {
        return this.settings.layout.isCollapsedText;
    }

    toggleFullScreen(event: any) {

        if (screenfull.enabled) {
            screenfull.toggle();
        }
        // Switch icon indicator
        let el = $(this.fsbutton.nativeElement);
        if (screenfull.isFullscreen) {
            el.children('em').removeClass('fa-expand').addClass('fa-compress');
        } else {
            el.children('em').removeClass('fa-compress').addClass('fa-expand');
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/layout/header/header.component.ts